import { ROUTES } from "@editor/ui-utils";
const de = {
  catTool: {
    openButton: "CatTool öffnen"
  }
};
const en = {
  catTool: {
    openButton: "Open CatTool"
  }
};
const messages = { en, de };
const routes = [
  {
    path: `/${ROUTES.catTool.path}`,
    meta: { i18RouteTitleKey: ROUTES.catTool.path },
    children: [
      {
        path: "",
        name: "cat_tool_entrypoint",
        component: () => import("./cat-tool-entrypoint.view-CAlBVus8.js"),
        meta: { requiredRight: "navigate_entrypoint_cat_tool" }
      }
    ]
  }
];
const catToolModule = {
  messages,
  routes,
  contentBlocks: []
};
export {
  catToolModule
};
//# sourceMappingURL=index.es.js.map
